import {
  BoundRadioGroupField,
  BoundSelectField,
  Button,
  Css,
  ModalBody,
  ModalFooter,
  ModalHeader,
  useModal,
} from "@homebound/beam";
import { Observer } from "mobx-react";
import { BidContractType, Maybe, SaveBidContractInput } from "src/generated/graphqlTypes";
import { BidPackageDetailActiveRequestFragment } from "src/routes/bids/BidPackageDetailPage.generated";
import { ObjectConfig, required, useFormState } from "src/utils/formState";

type SelectProrationModalProps = {
  requests: BidPackageDetailActiveRequestFragment[];
  bidPackageName: string;
  onContinue: (tradePartnerId: Maybe<string>, type: BidContractType) => void;
  isInternalEstimate: boolean;
};

export function SelectProrationModal({
  bidPackageName,
  requests,
  onContinue,
  isInternalEstimate = false,
}: SelectProrationModalProps) {
  const { closeModal } = useModal();
  const tradePartners = requests.map((request) => request.tradePartner);
  const formState = useFormState({
    config: getFormConfig(isInternalEstimate),
    init: {
      onlyOnce: true,
      input: { tradePartnerId: isInternalEstimate ? undefined : tradePartners[0].id },
    },
  });

  return (
    <>
      <ModalHeader>Prorate {bidPackageName} Bid</ModalHeader>
      <ModalBody>
        <div css={Css.df.fdc.gap3.$}>
          {!isInternalEstimate && (
            <BoundSelectField field={formState.tradePartnerId} label="Select Trade:" options={tradePartners} />
          )}

          <BoundRadioGroupField
            field={formState.type}
            label="Select Bid Format"
            options={[
              { label: "Grouped By Material", value: BidContractType.GroupedByMaterial },
              { label: "Plan and Option", value: BidContractType.GroupedByPlanAndOption },
            ]}
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button label="Cancel" variant="quaternary" onClick={() => closeModal()} />
        <Observer>
          {() => (
            <Button
              label="Continue"
              disabled={!formState.valid}
              onClick={() => onContinue(formState.tradePartnerId.value!, formState.type.value!)}
            />
          )}
        </Observer>
      </ModalFooter>
    </>
  );
}

type FormValues = Pick<SaveBidContractInput, "tradePartnerId" | "type">;

function getFormConfig(isInternalEstimate: boolean): ObjectConfig<FormValues> {
  return {
    tradePartnerId: { type: "value", rules: isInternalEstimate ? [] : [required] },
    type: { type: "value", rules: [required] },
  };
}
